import React from 'react'
const STOCKIN_TYPE_CHOICE = [
    "NEW MATERIAL",
    "RETURN MATERIAL",
    "BORROWING MATERIAL",
    "MATERIAL CONSUMPTION",
    "RETURN BORROWED MATERIAL",
    "LENDING MATERIAL",
    "RECEIVE LENT MATERIAL",
    "RESERVATION",
    "REQUISITION",
]

const StockHistoryTypeBadge = ({ historyType = "NEW MATERIAL" }) => {
    let badgeColor = "badge-success"
    if (historyType === STOCKIN_TYPE_CHOICE[1]) {
        badgeColor = "badge-success"
    } else if (historyType === STOCKIN_TYPE_CHOICE[2]) {
        badgeColor = "badge-info"
    } else if (historyType === STOCKIN_TYPE_CHOICE[3]) {
        badgeColor = "badge-danger"
    } else if (historyType === STOCKIN_TYPE_CHOICE[4]) {
        badgeColor = "badge-warning"
    }else if (historyType === STOCKIN_TYPE_CHOICE[5]) {
        badgeColor = "badge-danger"
    } else if (historyType === STOCKIN_TYPE_CHOICE[6]) {
        badgeColor = "badge-info"
    }
    else if (historyType === STOCKIN_TYPE_CHOICE[7]) {
        badgeColor = "badge-success"
    }
    else if (historyType === STOCKIN_TYPE_CHOICE[8]) {
        badgeColor = "badge-danger"
    }
    return (
        <span className={`badge light badge-sm border-0 ${badgeColor}`}>{historyType}</span>

    )
}

export default StockHistoryTypeBadge